<svg class="hide-safari" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
  <defs>
      <path d="M21.312,0 C22.037337,0 22.666664,0.266664 23.2,0.8 C23.733336,1.333336 24,1.96266304 24,2.688 L24,21.312 C24,22.037337 23.733336,22.666664 23.2,23.2 C22.666664,23.733336 22.037337,24 21.312,24 L2.688,24 C1.9413296,24 1.30666928,23.733336 0.784,23.2 C0.26133072,22.666664 0,22.037337 0,21.312 L0,16 L2.688,16 L2.688,21.312 L21.312,21.312 L21.312,2.688 L2.688,2.688 L2.688,8 L0,8 L0,2.688 C0,1.96266304 0.26133072,1.333336 0.784,0.8 C1.30666928,0.266664 1.9413296,0 2.688,0 L21.312,0 Z M9.44,16.8 L12.864,13.312 L0,13.312 L0,10.688 L12.864,10.688 L9.44,7.2 L11.328,5.312 L18.016,12 L11.328,18.688 L9.44,16.8 Z" id="logout"></path>
  </defs>
  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="04_Icons/small/exit">
          <mask id="logout1" fill="white">
              <use xlink:href="#logout"></use>
          </mask>
          <use id="Mask" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#logout"></use>
          <g id="00_Basic/Colors/red2" mask="url(#logout1)" fill="#BE0F0F" fill-rule="evenodd">
              <polygon id="box" points="0 0 24 0 24 24 0 24"></polygon>
          </g>
      </g>
  </g>
</svg>
<img src="assets/SVG/logout.png" width="24" height="24" class="show-safari" alt="Logout"/>
